export default "__VITE_ASSET__C$J3gr_z__"